import { SectionLoader } from '@/shared/components/section-loader';

export default SectionLoader;
